var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component, Inject, Watch } from 'vue-property-decorator';
import { INJECT_UICORE_BUS, INJECT_UICORE_DESIGNER } from "../../lib/utils/consts";
import { get, isEqual, pickBy, cloneDeep, uniqBy, groupBy, difference, merge, isEmpty } from "lodash-es";
import { getHashValue, trimUnit } from "../../lib/comps/PropPanel/StylePanel/utils/func";
import { getStyleAfterUnitCompletion } from "../../lib/comps/PropPanel/StylePanel/utils/styleUtils";
import { vueDeepSet } from "../../lib/utils/vue";
import { vueDeepDelete } from "../../lib/utils/vue/vueDeepAssign";
import { compileLayoutExtraStyle, compileSCSS } from "../../lib/utils/styling";
import { uuidv4, walkLayout } from "../../lib/utils";
import { highlightRect } from "../../lib/utils/browser";
function isRootSelector(selector, pseudo) {
  return selector === '' && pseudo === '';
}
const DEFAULT_SELECTOR = {
  selector: '',
  name: '组件整体'
};
const DEFAULT_PSEUDO = [{
  name: '常态',
  selector: ''
}, {
  name: '鼠标悬浮',
  selector: '&:hover'
}];
function getSelectorsFromExtraStyle(extraStyle) {
  if (!extraStyle) return [];
  const selectorList = [];
  Object.entries(extraStyle).forEach(([selector, selectorInfo]) => {
    const selectorTemp = {
      selector,
      name: selector,
      custom: true
    };
    Object.keys(selectorInfo).forEach(pseudo => {
      selectorTemp.pseudoClasses = [...(selectorTemp.pseudoClasses || []), {
        name: pseudo || '常态',
        selector: pseudo,
        custom: true
      }];
    });
    selectorList.push(selectorTemp);
  });
  return selectorList;
}
let StylePanelState = class StylePanelState extends Vue {
  constructor() {
    super(...arguments);
    /** 又可以用$set触发 又可以用直接赋值触发 */
    this.styles = {};
    this.currentSelector = '';
    this.currentPseudoClass = '';
    // #endregion
  }
  get compPath() {
    return this.designer.compPath;
  }
  /** 组件提供的全部selectors */
  get selectors() {
    const selectorsFromMeta = this.getSelectorsByCompPath(this.compPath);
    const selectorsFromExtraStyle = this.getSelectorsFromExtraStyle(this.compPath);
    const selectorsGrouped = groupBy([...selectorsFromMeta, ...selectorsFromExtraStyle], 'selector');
    const mergedSelectors = Object.values(selectorsGrouped).map(selectors => {
      const pseudoClasses = selectors.map(selector => selector.pseudoClasses || []).flat();
      // uniqBy 去重时先出现的优先使用
      const pseudoClassesUnique = uniqBy(pseudoClasses, 'selector');
      return {
        ...selectors[0],
        pseudoClasses: pseudoClassesUnique
      };
    });
    return mergedSelectors;
  }
  getSelectorsByCompPath(compPath) {
    const comp = this.compPath === compPath ? this.designer.activeComp : this.designer.getCompAtPath(compPath);
    const type = comp === null || comp === void 0 ? void 0 : comp.type;
    if (!type) return [DEFAULT_SELECTOR];
    const meta = this.designer.uc.components[type];
    const getSelectors = () => {
      var _meta$stylePanel2;
      if (typeof (meta === null || meta === void 0 ? void 0 : meta.stylePanel) === 'function') {
        var _meta$stylePanel;
        const ctx = this.designer.getComponentDesignerContext(compPath);
        return (_meta$stylePanel = meta.stylePanel(ctx)) === null || _meta$stylePanel === void 0 ? void 0 : _meta$stylePanel.selectors;
      }
      return meta === null || meta === void 0 || (_meta$stylePanel2 = meta.stylePanel) === null || _meta$stylePanel2 === void 0 ? void 0 : _meta$stylePanel2.selectors;
    };
    const selectors = getSelectors();
    if (!(selectors !== null && selectors !== void 0 && selectors.length)) {
      return [DEFAULT_SELECTOR];
    }
    if (!selectors.find(selector => selector.selector === '')) {
      // 补充默认的
      return [DEFAULT_SELECTOR, ...selectors];
    }
    return selectors;
  }
  getSelectorsFromExtraStyle(compPath) {
    const comp = this.compPath === compPath ? this.designer.activeComp : this.designer.getCompAtPath(compPath);
    return getSelectorsFromExtraStyle(comp === null || comp === void 0 ? void 0 : comp.extraStyle);
  }
  get isRootSelector() {
    return this.currentSelector === '' && this.currentPseudoClass === '';
  }
  get inlineStyleProps() {
    const comp = this.designer.activeComp;
    return cloneDeep(get(comp, 'inlineStyleProps', []));
  }
  set inlineStyleProps(val) {
    if (val.length === this.inlineStyleProps.length && difference(val, this.inlineStyleProps).length === 0) return;
    this.designer.modifyComp(this.compPath, comp => {
      if (val.length === 0) {
        vueDeepDelete(comp, 'inlineStyleProps');
        return;
      }
      vueDeepSet(comp, 'inlineStyleProps', val);
    });
  }
  get innerStyles() {
    // 1 extStyle 2 comp.style=> extraStyle "" ""
    // 3 styleSheetName 追加只读展示(后续)
    const layoutStyle = this.getStylesBySelector();
    return layoutStyle;
  }
  set innerStyles(val) {
    const comp = this.designer.activeComp;
    if (!comp) {
      console.error('[StylePanelState]找不到组件');
      return;
    }
    const {
      compPath
    } = this.designer;
    this.setStylesBySelector(val, {
      compPath
    });
  }
  /** 即使是空对象 挂到styles上之后也可以被有效的监听修改 同时deepclone一次断开和pagelet的响应式连接*/
  innerStylesChanged(newVal) {
    if (isEqual(newVal, this.styles)) return;
    this.styles = cloneDeep(newVal);
  }
  /** 允许外部的$set 修改styles子元素并且可以触发响应式监听 */
  setInnerStyles(newVal) {
    if (isEqual(newVal, this.innerStyles)) return;
    this.innerStyles = this.styles;
  }
  getStylesBySelector(opts = {}) {
    const {
      compPath,
      selector,
      pseudo
    } = this.getCompAndPath(opts);
    const comp = this.compPath === compPath ? this.designer.activeComp : this.designer.getCompAtPath(compPath);
    const stylePath = isRootSelector(selector, pseudo) ? 'style' : ['extraStyle', selector, pseudo];
    return get(comp, stylePath, {});
  }
  async addConditionStyleBySelector(opts = {}) {
    const {
      compPath,
      selector,
      pseudo
    } = this.getCompAndPath(opts);
    await this.designer.modifyComp(compPath, comp => {
      const path = ['conditionStyle', selector, pseudo];
      const conditionStyles = this.getConditionStylesBySelector({
        compPath,
        selector,
        pseudo
      });
      if (this.isConditionStyleHasEmpty(conditionStyles)) return;
      vueDeepSet(comp, path, [...conditionStyles, {
        cond: '',
        style: {}
      }]);
    });
  }
  isConditionStyleHasEmpty(conditionStyles, hasEmpty = true) {
    return conditionStyles.findIndex(item => hasEmpty ? !item.cond && isEmpty(item.style) : item.cond || !isEmpty(item.style)) > -1;
  }
  async setConditionStyleBySelector(index, cond, style, opts = {}) {
    const {
      compPath,
      selector,
      pseudo
    } = this.getCompAndPath(opts);
    await this.designer.modifyComp(compPath, comp => {
      const path = ['conditionStyle', selector, pseudo, index];
      const oldConditionStyle = get(comp, path);
      vueDeepSet(comp, path, {
        cond: cond !== null && cond !== void 0 ? cond : oldConditionStyle === null || oldConditionStyle === void 0 ? void 0 : oldConditionStyle.cond,
        style: style !== null && style !== void 0 ? style : oldConditionStyle === null || oldConditionStyle === void 0 ? void 0 : oldConditionStyle.style
      });
    });
  }
  getCompAndPath(opts = {}) {
    var _opts$compPath, _opts$selector, _opts$pseudo;
    const compPath = (_opts$compPath = opts.compPath) !== null && _opts$compPath !== void 0 ? _opts$compPath : this.compPath;
    const selector = (_opts$selector = opts.selector) !== null && _opts$selector !== void 0 ? _opts$selector : this.currentSelector;
    const pseudo = (_opts$pseudo = opts.pseudo) !== null && _opts$pseudo !== void 0 ? _opts$pseudo : this.currentPseudoClass;
    return {
      compPath,
      selector,
      pseudo
    };
  }
  getStyleMail(styles) {
    // 补充px单位
    const mpStyleObj = getStyleAfterUnitCompletion(styles);
    const styleMail = pickBy({
      ...styles,
      ...mpStyleObj
    }, v => v !== undefined && v !== ''); // 0值是允许的
    return styleMail;
  }
  getConditionStylesBySelector(opts = {}) {
    const {
      compPath,
      selector,
      pseudo
    } = this.getCompAndPath(opts);
    const comp = this.compPath === compPath ? this.designer.activeComp : this.designer.getCompAtPath(compPath);
    const path = ['conditionStyle', selector, pseudo];
    return get(comp, path, []);
  }
  async deleteConditionStyle(index, opts = {}) {
    const {
      compPath,
      selector,
      pseudo
    } = this.getCompAndPath(opts);
    this.designer.modifyComp(compPath, comp => {
      const path = ['conditionStyle', selector, pseudo, index];
      vueDeepDelete(comp, path);
    });
  }
  async deleteExtraStyles(opts = {}) {
    var _opts$compPath2, _opts$selector2, _opts$pseudo2;
    const compPath = (_opts$compPath2 = opts.compPath) !== null && _opts$compPath2 !== void 0 ? _opts$compPath2 : this.compPath;
    const selector = (_opts$selector2 = opts.selector) !== null && _opts$selector2 !== void 0 ? _opts$selector2 : this.currentSelector;
    const pseudo = (_opts$pseudo2 = opts.pseudo) !== null && _opts$pseudo2 !== void 0 ? _opts$pseudo2 : this.currentPseudoClass;
    this.designer.modifyComp(compPath, comp => {
      const stylePath = pseudo === false ? ['extraStyle', selector] : ['extraStyle', selector, pseudo];
      vueDeepDelete(comp, stylePath);
      const condstylePath = pseudo === false ? ['conditionStyle', selector] : ['conditionStyle', selector, pseudo];
      vueDeepDelete(comp, condstylePath);
    });
  }
  async setStylesBySelector(newStyles, opts = {}) {
    var _opts$oldStyles;
    const {
      compPath,
      selector,
      pseudo
    } = this.getCompAndPath(opts);
    const oldStyles = (_opts$oldStyles = opts.oldStyles) !== null && _opts$oldStyles !== void 0 ? _opts$oldStyles : this.innerStyles;
    const trimedOldStyle = trimUnit({
      ...oldStyles
    });
    // equal旧样式并且是在调整当前选择器的样式 就可以跳出
    if (isEqual(trimedOldStyle, newStyles) && selector === this.currentSelector && pseudo === this.currentPseudoClass) {
      return;
    }
    await this.designer.modifyComp(compPath, comp => {
      const styleMail = this.getStyleMail(newStyles);
      const selectors = this.getSelectorsByCompPath(compPath);
      // 当新的样式属于预设的selector时才尝试进行deepDelete清理 防止用户自定义的class选择器被干掉
      const isEmptyStyle = Object.keys(styleMail).length === 0 && selectors.find(item => item.selector === selector);
      const stylePath = isRootSelector(selector, pseudo) ? 'style' : ['extraStyle', selector, pseudo];
      if (isEmptyStyle) {
        // deepdelete会清理掉watch
        // vueDeepDelete(comp, stylePath);
        vueDeepSet(comp, stylePath, {});
      } else {
        vueDeepSet(comp, stylePath, styleMail);
      }
    });
  }
  async addSelectorOrPseudo(opts = {}) {
    const style = this.getStylesBySelector(opts);
    await this.setStylesBySelector(style, opts);
  }
  get currentSelectorInfo() {
    return this.selectors.find(x => x.selector === this.currentSelector);
  }
  getPseudoClassesFromSelector(selector) {
    const info = this.selectors.find(x => x.selector === selector);
    const ans = (info === null || info === void 0 ? void 0 : info.pseudoClasses) || [];
    return uniqBy([...DEFAULT_PSEUDO, ...ans], 'selector');
  }
  get pseudoClasses() {
    return this.getPseudoClassesFromSelector(this.currentSelector);
  }
  get currentPseudoClassInfo() {
    return this.pseudoClasses.find(x => x.selector === this.currentPseudoClass);
  }
  created() {
    this.$watch(() => !this.currentSelectorInfo, needReset => {
      var _this$selectors$;
      return needReset && (this.currentSelector = ((_this$selectors$ = this.selectors[0]) === null || _this$selectors$ === void 0 ? void 0 : _this$selectors$.selector) || '');
    });
    this.$watch(() => !this.currentPseudoClassInfo, needReset => {
      var _this$pseudoClasses$;
      return needReset && (this.currentPseudoClass = ((_this$pseudoClasses$ = this.pseudoClasses[0]) === null || _this$pseudoClasses$ === void 0 ? void 0 : _this$pseudoClasses$.selector) || '');
    });
    // 切换组件的时候，重置当前激活的 pseudoClasses
    this.$watch(() => [this.compPath, this.designer.renderer], () => this.currentPseudoClass = '');
  }
  // #region 样式模板相关
  /** 把当前的所有样式都收集为样式模板 */
  style2Source(opts = {}) {
    var _opts$ignoreInterop;
    const comp = this.designer.activeComp;
    const ignoreInterop = (_opts$ignoreInterop = opts.ignoreInterop) !== null && _opts$ignoreInterop !== void 0 ? _opts$ignoreInterop : true;
    const rootStyle = {
      '': {
        '': this.getStylesBySelector({
          selector: '',
          pseudo: ''
        })
      }
    };
    const extStyle = get(comp, 'extraStyle', {});
    const selfStyle = {
      '': extStyle['']
    };
    const rootsource = compileLayoutExtraStyle(merge({}, rootStyle, selfStyle), {
      ignoreInterop
    }).split('\n').map(item => `${item}`).join('\n');
    const rootStr = `${rootsource}\n`;
    const extsourceArray = Object.entries(extStyle).map(([selector, style]) => {
      // 跳过root selector
      if (!selector) return;
      const extsource = compileLayoutExtraStyle({
        [selector]: style
      }, {
        ignoreInterop
      });
      const extStr = `${extsource}`;
      // 偷个懒 没分号肯定是空的了
      if (!extStr.includes(';')) return '';
      return extStr;
    });
    const source = rootStr + extsourceArray.join('\n').trimEnd();
    return source;
  }
  generateStyleSheet(name, source, opts = {}) {
    const uuid = getHashValue(uuidv4());
    const styleSheetsId = opts.styleSheetsId || `uc-public-style-${uuid}`;
    const styleDetail = {
      id: styleSheetsId,
      name,
      source
    };
    if (opts.componentType) {
      styleDetail.componentTypes = [opts.componentType];
    }
    return styleDetail;
  }
  commitStyleSheet(sheet) {
    const styleSheetsArray = get(this.designer.rootPagelet, 'styleSheets', []);
    const index = styleSheetsArray.findIndex(x => x.id === sheet.id);
    if (index === -1) {
      styleSheetsArray.unshift(sheet);
    } else {
      styleSheetsArray.splice(index, 1, sheet);
    }
    // 如果不是新建 新的会覆盖旧的
    const styleSheetsUnique = uniqBy(styleSheetsArray, 'id');
    this.$set(this.designer.rootPagelet, 'styleSheets', styleSheetsUnique);
    this.uc.notifyPageletsChange();
  }
  deleteStyleSheet(sheet) {
    var _this$designer$pagele;
    // 递归跑所有的layout 然后unMount一遍
    walkLayout((_this$designer$pagele = this.designer.pagelet) === null || _this$designer$pagele === void 0 ? void 0 : _this$designer$pagele.layout, ({
      layout,
      compPath
    }) => {
      if (!layout.styleSheetName) return;
      this.unMountStyleSheet(sheet.id, compPath);
    });
    // 然后删styleSheets里的
    const styleSheetsArray = get(this.designer.rootPagelet, 'styleSheets', []);
    const styleSheetsArrayDeleted = styleSheetsArray.filter(item => item.id !== sheet.id);
    this.$set(this.designer.rootPagelet, 'styleSheets', styleSheetsArrayDeleted);
    this.uc.notifyPageletsChange();
  }
  async mountStyleSheet(sheetId, compPathArg) {
    const compPath = compPathArg !== null && compPathArg !== void 0 ? compPathArg : this.compPath;
    await this.designer.modifyComp(compPath, comp => {
      const styleSheetIdArray = comp.styleSheetName || [];
      styleSheetIdArray.push(sheetId);
      this.assignStyleSheet(styleSheetIdArray, compPath);
    });
  }
  async unMountStyleSheet(sheetId, compPathArg) {
    const compPath = compPathArg !== null && compPathArg !== void 0 ? compPathArg : this.compPath;
    await this.designer.modifyComp(compPath, comp => {
      const styleSheetIdArray = comp.styleSheetName || [];
      const styleSheetIdFiltered = styleSheetIdArray.filter(item => item !== sheetId);
      if (styleSheetIdFiltered.length === styleSheetIdArray.length) return;
      this.assignStyleSheet(styleSheetIdFiltered, compPath);
    });
  }
  async assignStyleSheet(sheetIds, compPathArg) {
    const compPath = compPathArg !== null && compPathArg !== void 0 ? compPathArg : this.compPath;
    const uniqueIds = Array.from(new Set(sheetIds));
    await this.designer.modifyComp(compPath || this.compPath, comp => {
      this.$set(comp, 'styleSheetName', uniqueIds);
    });
  }
  get styleSheetList() {
    return get(this.designer.rootPagelet, 'styleSheets', []);
  }
  get currentActiveStyleSheetList() {
    const activeStyleSheetIds = get(this.designer.activeComp, 'styleSheetName', []);
    const activeStyleSheetList = this.styleSheetList.filter(item => activeStyleSheetIds.includes(item.id));
    return activeStyleSheetList;
  }
  /** 高亮当前的样式选区 */
  highlightSelectedRegion(opts = {}) {
    var _opts$selector3, _opts$compPath3, _this$designer$scope$;
    const selector = (_opts$selector3 = opts.selector) !== null && _opts$selector3 !== void 0 ? _opts$selector3 : this.currentSelector;
    if (!selector) return;
    const compPath = (_opts$compPath3 = opts.compPath) !== null && _opts$compPath3 !== void 0 ? _opts$compPath3 : this.compPath;
    const instance = (_this$designer$scope$ = this.designer.scope.renderer) === null || _this$designer$scope$ === void 0 ? void 0 : _this$designer$scope$.getRefByPath(compPath);
    if (!instance) return;
    const styleKey = `uc-componentHover-${uuidv4()}`;
    instance.$el.setAttribute(styleKey, '');
    const cssPrefix = `*[${styleKey}] {`;
    const css = compileLayoutExtraStyle({
      [selector]: {
        '': {
          color: 'red'
        }
      }
    });
    const cssSuffix = '}';
    const serialize = compileSCSS(cssPrefix + css + cssSuffix);
    // 把后面的style部分替换掉 留下css选择器
    const cssQuery = serialize.replace(/\{[\s\S]*\}/, '');
    try {
      const elements = instance.$el.querySelectorAll(cssQuery);
      elements.forEach(el => {
        highlightRect(el.getBoundingClientRect(), 100, '', '#FFE83C6E');
      });
      instance.$el.removeAttribute(styleKey);
    } catch (e) {
      // 有时候会拼不成合法selector导致报错
    }
  }
};
__decorate([Inject({
  from: INJECT_UICORE_BUS
})], StylePanelState.prototype, "uc", void 0);
__decorate([Inject({
  from: INJECT_UICORE_DESIGNER
})], StylePanelState.prototype, "designer", void 0);
__decorate([Watch('innerStyles', {
  deep: true,
  immediate: true
})], StylePanelState.prototype, "innerStylesChanged", null);
__decorate([Watch('styles', {
  deep: true,
  immediate: true
})], StylePanelState.prototype, "setInnerStyles", null);
StylePanelState = __decorate([Component({
  name: 'StylePanelState'
})], StylePanelState);
export { StylePanelState };
//# sourceMappingURL=StylePanelState.js.map
